import {styled} from '@mui/material';

export const SidebarWrapper = styled('div')(({theme}) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(3),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  background: `linear-gradient(-20deg, ${theme.palette.secondary.main}23, ${theme.palette.secondary.light}, ${theme.palette.secondary.light}, ${theme.palette.secondary.main}23)`,
  [theme.breakpoints.up('sm')]: {
    height: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}));

export const ProfileImage = styled('div')(({theme}) => ({
  cursor: 'pointer',
  width: '100%',
  marginTop: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    minHeight: '200px'
  }
}));
